<template>
    <v-app style="background-color: #f5f5f5;">
        <app-navigation v-if="!['login'].includes($route.name)"></app-navigation>
        <v-main>
            <router-view></router-view>
            <router-link to="/dashboard"></router-link>
        </v-main>
        <vue-snotify></vue-snotify>
    </v-app>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import AppNavigation from '@/components/AppNavigation.vue';
import { TokenUtils } from '@/utils/TokenUtils';
import UserService from '@/services/UserService';
import * as AppUtils from '@/utils/AppUtils';
import router from '@/router';
import { makeClientOrderFromData } from '@/serializers/Delivery.serializer';
import DeliveryService from '@/services/DeliveryService';

let socket = null;
let socketSystem = null;
let shouldReconnect = true;

export default {
  name: 'App',

  components: {
    AppNavigation,
  },

  data: () => ({
  }),

  methods: {
    ...mapMutations(['INCREMENT_NEW_CLIENT_ORDER']),
    ...mapActions([
      'setAuthUserData',
      'setAttributes',
    ]),

    connectSocket() {
      if (socket) {
        socket.onclose = null;
        socket.close();
      }
      const wsUrl = `${process.env.VUE_APP_SOCKET}/orders-app`;
      socket = new WebSocket(wsUrl);
      console.log('🚀 ~ socket:', socket);

      socket.onmessage = (event) => {
        const { data, event: eventType } = JSON.parse(event.data);
        if (!data) return;
        if (eventType === 'new_order') {
          const order = makeClientOrderFromData({ ...data, isNew: true });
          this.INCREMENT_NEW_CLIENT_ORDER();
          this.$snotify.info(`New order #${order.id} from ${order.clientName}`, 'New Order', { timeout: 5000 });
          this.$root.$emit('socket:new_order', order);
        }
      };

      socket.onerror = error => console.error('WebSocket error:', error);
      socket.onclose = (e) => {
        console.log('🚀 ~ e:', e);
        if (shouldReconnect) {
          setTimeout(() => this.connectSocket(), 5000);
        }
      };
    },


    connectSystemSocket() {
      if (socketSystem) {
        socketSystem.onclose = null;
        socketSystem.close();
      }
      const wsUrl = `${process.env.VUE_APP_SYSTEM_SOCKET}/orders`;
      socketSystem = new WebSocket(wsUrl);

      socketSystem.onmessage = (event) => {
        const { data, event: eventType } = JSON.parse(event.data);
        if (!data) return;
        if (eventType === 'new_order') {
          this.INCREMENT_NEW_CLIENT_ORDER();
          const order = makeClientOrderFromData({ ...data, isNew: true });
          if (router.currentRoute.name !== 'pos') {
            this.$snotify.info(`New order #${order.id} from ${order.clientName}`, 'New Order', { timeout: 5000 });
          }
          this.$root.$emit('socket:new_order', order);
          return;
        }
        if (eventType === 'close_order' || eventType === 'delete_order') {
          this.$root.$emit('socket:update_order_status', {
            id: data.id,
            status: data.status ?? data.regStatus,
          });
        }
      };

      socketSystem.onerror = error => console.error('WebSocket error:', error);
      socketSystem.onclose = () => {
        if (shouldReconnect) {
          setTimeout(() => this.connectSystemSocket(), 5000);
        }
      };
    },
  },

  async mounted() {
    shouldReconnect = true;
    if (TokenUtils.hasToken()) {
      // retrieve user attributes
      const payload = TokenUtils.getJwtData();
      const { identity: userId } = payload;

      const attributes = await UserService.getUserAttributes(userId);
      this.setAuthUserData(payload);
      this.setAttributes(attributes);
      this.connectSocket();
      this.connectSystemSocket();
      if (window.location.pathname === '/') {
        AppUtils.redirectToUserSectionByAttributes(this.$router, attributes);
      }
      try {
        const { count } = await DeliveryService.getNewClientOrdersCount();
        this.$store.dispatch('setNewClientOrderCount', count);
      } catch (e) {
        console.error('Failed to load new client orders count', e);
      }
    } else {
      this.$router.push('/login');
    }
  },

  beforeDestroy() {
    shouldReconnect = false;
    if (socket) { socket.onclose = null; socket.close(); socket = null; }
    if (socketSystem) { socketSystem.onclose = null; socketSystem.close(); socketSystem = null; }
  },
};
</script>

<style lang="less">
@import "~vue-snotify/styles/material.css";

.title-text {
  font-size: 2rem;
  font-weight: 300;
  color: #0d1d4e;
}

.subtitle-text {
  font-size: 1.2rem;
  font-weight: 300;
  margin-bottom: 0 !important;
}

.swal2-popup {
  font-family: 'Roboto', sans-serif !important;
}

.success-notif {
  background-color: #4ed289;
  color: white;

  .title {
    color: white;
  }
}

.snotifyToast {
  &__title {
    font-size: 1.2rem;
  }
}

.snotify-icon {
  max-width: 36px;
  max-height: 36px;
}

.snotify-async {
  background-color: #4e6dd2da;
}

.snotify-success {
  background-color: #4caf4fc9;
}

.snotify-error {
  background-color: #f44336da;
}
.center{
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}
.w-full{
  width: 100%;
}
.h-full{
  height: 100%;
}
.gap-2{
  gap: 0.5rem;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
</style>
